import anime from 'animejs';

class Helpers{
    getType(payload) {
        return Object.prototype.toString.call(payload).slice(8, -1).toLowerCase();
    }
    vnodeToHtmlString(slot) {
        try {
            const createAttributesString = (attr) => {
                if (!attr) return '';
                let attrString = '';

                for (let key in attr) {
                    attrString += `${ key }="${ attr[ key ] }" `;
                }

                return attrString;
            }

            if (!Array.isArray(slot) && slot.children) {
                slot = [ slot ]
            }

            const createDom = (slotLevel) => {
                let domString = '';

                for (let el of slotLevel) {
                    if (el.type) {
                        domString += `
							<${ el.type } ${ createAttributesString(el?.props) }>
								${ el.children && Array.isArray(el.children) ? createDom(el.children) : el.children }					
							</${ el.type }>`
                        ;
                    }
                    // else {
                    // 	domString += el.text;
                    // }
                    // if (typeof el.children === 'string') {
                    // 	console.log('123');
                    // 	domString += el.text;
                    // }
                }

                return domString;
            }

            // return document.createRange().createContextualFragment(createDom(slot));
            return createDom(slot);
        } catch (err) {
            console.error(err);
        }
    }
    scrollPageTo(scrollTop = 0, duration = 500) {
        const scrollElement =
            window.document.scrollingElement ||
            window.document.body ||
            window.document.documentElement;

        anime({
            targets: scrollElement,
            easing: 'easeInOutQuad',
            scrollTop,
            duration,
        })
    }
    getFirstElementObject(obj) {
        return obj[ Object.keys(obj)[0] ];
    }
    setCookie(name, value, expDays) {
        try {
            if (expDays) {
                let date = new Date();
                date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
                const expires = "expires=" + date.toUTCString();
                document.cookie = `${ name } = ${ value }; ${ expires }; path=/`;
            } else {
                document.cookie = `${ name } = ${ value }; path=/`;
            }

        } catch (err) {
            console.error(err);
        }
    }
    getCookie(cName) {
        try {
            const name = cName + "=";
            const cDecoded = decodeURIComponent(document.cookie); //to be careful
            const cArr = cDecoded .split('; ');
            let res;
            cArr.forEach(val => {
                if (val.indexOf(name) === 0) res = val.substring(name.length);
            })
            return res;
        } catch (err) {
            console.error(err);
        }
    }

    downloadURI(uri, name)
    {
        const link = document.createElement("a");
        link.setAttribute('download', name);
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    b64EncodeUnicode(str) {
        // first we use encodeURIComponent to get percent-encoded UTF-8,
        // then we convert the percent encodings into raw bytes which
        // can be fed into btoa.
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode('0x' + p1);
            }));
    };

    b64DecodeUnicode(str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(str).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    };
}

export default Helpers;